import { action } from '@ember/object';
// eslint-disable-next-line ember/no-at-ember-render-modifiers
import { didInsert, didUpdate } from '@ember/render-modifiers';
import { PrismButton } from '@mylighthouse/prism-ember';
import GeneralDayDetailChartsChartRatesEvolution from 'lumen/components/general/day-detail/charts/chart-rates-evolution';
import GeneralDayDetailTabsTabDayDetailBase from 'lumen/components/general/day-detail/tabs/tab-day-detail-base';
import GeneralEmptyStateOtbBanner from 'lumen/components/general/empty-state-otb-banner';
import GeneralModalFilterBar from 'lumen/components/general/modal-filter-bar';
import displayRateParityFilters from 'lumen/helpers/display-rate-parity-filters';
import {
  OTB_SS_ENTRY_POINTS,
  OTB_SS_VIA_QP_VALUES,
} from 'lumen/utils/constants/otb-selfservice-constants';

// @ts-expect-error: Incorrect type
export default class GeneralDayDetailTabsTabRatesEvolution extends GeneralDayDetailTabsTabDayDetailBase {
  OTB_SS_ENTRY_POINTS = OTB_SS_ENTRY_POINTS;

  OTB_SS_VIA_QP_VALUES = OTB_SS_VIA_QP_VALUES;

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get correctedWidth() {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Math.floor(this.args.params.width * 0.9);
  }

  // Should the left arrow be visible
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get leftLimit() {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return this.args.params.offset < 90;
  }

  // Should the right arrow be visisble
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get rightLimit() {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return this.args.params.offset !== 0;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get sortedPeriodsOTB() {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return
    return this.model.periodsOTB.toSorted(
      // @ts-expect-error: Incorrect type
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      (periodA, periodB) => periodA.id - periodB.id,
    );
  }

  @action
  decreaseOffset(): void {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
    const { offset } = this.args.params;
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
    this.args.params.updateOffset(offset + 30);
  }

  @action
  increaseOffset(): void {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
    const { offset } = this.args.params;
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
    this.args.params.updateOffset(offset - 30);
  }

  <template>
    <GeneralModalFilterBar class="flex justify-between">
      <div class="modal-filter-bar__filter-text truncate">
        {{#if @isPricingAssistantProduct}}
          {{displayRateParityFilters
            @filteredRatesParamsForPricingAssistant
            @params.currentHotel
          }}
        {{else}}
          {{displayRateParityFilters @params.ratesParams @params.currentHotel}}
        {{/if}}
      </div>
    </GeneralModalFilterBar>
    {{#if @params.hasOtbSelfServiceEntryPoint}}
      <div
        {{didInsert this.setBannerHeight}}
        {{didUpdate this.setBannerHeight @params.height @isLoading}}
      >
        <GeneralEmptyStateOtbBanner
          @bannerPosition="top"
          @otbSelfServiceEntryPoint={{this.OTB_SS_ENTRY_POINTS.RATES_EVOLUTION_CHART}}
          @otbSelfServiceEntryProduct={{this.OTB_SS_VIA_QP_VALUES.RATE_INSIGHT}}
        />
      </div>
    {{/if}}
    <div class="rates-evolution-container">
      <div
        class="left-side-container"
        data-event-id="rates-evolution-offset-increase"
      >
        {{#if this.leftLimit}}
          <div class="offset-arrow-btn">
            <PrismButton
              @buttonType="secondary"
              @icon="arrow-left"
              @onClick={{this.decreaseOffset}}
            />
          </div>
        {{/if}}
      </div>
      <div class="re-curve">
        <GeneralDayDetailChartsChartRatesEvolution
          {{! @glint-expect-error: Incorrect type }}
          @activeCompset={{@params.activeCompset}}
          @competitorsForCurrentHotelAndOTA={{@params.competitorsForCurrentHotelAndOTA}}
          @containerHeight={{this.correctedHeight}}
          @correctedWidth={{this.correctedWidth}}
          @currency={{@params.currency}}
          @dayMoment={{@params.dayMoment}}
          @hotelObject={{@params.currentHotel}}
          @isBestFlex={{@params.isBestFlex}}
          @isLoading={{@isLoading}}
          @otaId={{@params.otaId}}
          @params={{@params}}
          @periods={{this.model.periods}}
          @rentalData={{this.model.rental}}
          @sortedPeriodsOTB={{this.sortedPeriodsOTB}}
        />
      </div>
      <div
        class="right-side-container"
        data-event-id="rates-evolution-offset-decrease"
      >
        {{#if this.rightLimit}}
          <div class="offset-arrow-btn">
            <PrismButton
              @buttonType="secondary"
              @icon="arrow-right"
              @onClick={{this.increaseOffset}}
            />
          </div>
        {{/if}}
      </div>
    </div>
  </template>
}
